import React from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { requiredCell, validateEmail, validatePhoneNumber, validateRequiredSelectCell } from "../../js/utils/inputValidations";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import { SelectGrid } from "../Widgets/Custom Inputs/Select";
import { optionsExternalProviderType } from "../../js/constants/selectOptions";


const mapTypeLabel = value => {
    if (value === null || value === undefined || value === "" || value === 0 || value === "0") {
        return "";
    }

    if (value === 1 || value === "1") {
        return t("field.Laboratory");
    }

    if (value === 2 || value === "2") {
        return t("field.ConsultingFirm");
    }

    return "";
};

const ExternalProviderGrid = ({ label = t("grid.title.ExternalProviders"), baseURL }) => {
    const apiRef = useGridApiRef();
    const cellFocusField = "Name";

    const gridSpecificColumns = [
        {
            field: "Name",
            headerName: t("field.Name"),
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "Name", "Name");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "Type",
            headerName: t("field.Type"),
            width: 140,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = validateRequiredSelectCell(
                    params,
                    apiRef,
                    t("field.ExternalProviderType"),
                    "Type",
                    t("input.validation.externalProviderTypeRequired"),
                    [1, 2]
                );
                return { ...params.props, error: hasError };
            },
            renderEditCell: params => {
                const options = optionsExternalProviderType?.map(e => ({
                    value: e.value === "Laboratory" ? 1 : 2,
                    label: t(e.label)
                }));
                const selectedOption =
                    options?.find(e => e.value === params?.value || String(e.value) === String(params?.value)) ?? null;
                return (
                    <SelectGrid
                        {...params}
                        options={options}
                        value={selectedOption}
                        defaultValue={selectedOption}
                        getOptionLabel={option => {
                            return option?.label ?? "";
                        }}
                    />
                );
            },
            valueFormatter: params => mapTypeLabel(params?.value),
        },
        {
            field: "EMail",
            headerName: "EMail",
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = validateEmail(
                    params,
                    apiRef,
                    "EMail",
                    "EMail"
                );
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "Phone",
            headerName: t("field.Phone"),
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = validatePhoneNumber(
                    params,
                    apiRef,
                    "Phone",
                    "Phone"
                );
                return { ...params.props, error: hasError };
            },
        }
    ];

    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={baseURL}
            cellFocusField={cellFocusField}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            initialState={{
                sorting: {
                    sortModel: [{ field: "Name", sort: "asc" }],
                },
            }}
        />
    );
};

export default ExternalProviderGrid;
